import { createAction } from 'redux-actions';
import { UserGroupAttributes } from './model';

export const userGroupCreationInitialized = createAction(
  '@platform/command/userGroups/create/init',
);
export const userGroupCreationSucceeded = createAction(
  '@platform/command/userGroups/create/success',
  (payload: any) => payload,
);
export const userGroupCreationFailed = createAction(
  '@platform/command/userGroups/create/failed',
);
export const userGroupUpdateInitialized = createAction<
Partial<UserGroupAttributes>, Partial<UserGroupAttributes>
>(
  '@platform/command/userGroups/update/init',
  payload => payload,
);
export const userGroupUpdateSucceeded = createAction<
Partial<UserGroupAttributes>, Partial<UserGroupAttributes>
>(
  '@platform/command/userGroups/update/success',
  payload => payload,
);
export const userGroupUpdateFailed = createAction(
  '@platform/command/userGroups/update/failed',
);
export const userGroupDeleteInitialized = createAction<string, string>(
  '@platform/command/userGroups/delete/init',
  id => id,
);
export const userGroupDeleteSucceeded = createAction<string, string>(
  '@platform/command/userGroups/delete/success',
  payload => payload,
);
export const userGroupDeleteFailed = createAction(
  '@platform/command/userGroups/delete/failed',
);
export const userGroupFetchInitialized = createAction(
  '@platform/query/userGroups/get/init',
);
export const userGroupFetchSucceeded = createAction(
  '@platform/query/userGroups/get/success',
  (payload: any) => payload,
);
export const userGroupFetchFailed = createAction(
  '@platform/query/userGroups/get/failed',
);
export const userGroupsFetchInitialized = createAction(
  '@platform/query/userGroups/list/init',
  (payload: any) => payload,
);
export const userGroupsFetchSucceeded = createAction(
  '@platform/query/userGroups/list/success',
  (payload: any) => payload,
);
export const userGroupsFetchFailed = createAction(
  '@platform/query/userGroups/list/failed',
);
export const configureUserGroupsFetch = createAction(
  '@platform/event/userGroups/configureFetch',
  (payload: any) => payload,
);
